import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import Subscription, { type ISubscription } from 'modules/expenses/store/models/subscription'

class Subscriptions extends Collection<Subscription> {
  constructor(data: ISubscription[] = []) {
    super(data)
    makeObservable(this, {
      current: computed,
    })
  }

  get cacheKey(): string {
    return 'expensesSubscriptions'
  }

  model() {
    return Subscription
  }

  get current(): Subscription {
    const subscription = this.at(0)

    if (!subscription) {
      throw Error('Error finding current expenses plan')
    }

    return subscription
  }
}

const singleton: Subscriptions = new Subscriptions()

export default singleton

const { provider: SubscriptionsProvider, hook: useSubscriptions } = createCollectionContext<
  Subscription,
  Subscriptions
>()

export { SubscriptionsProvider, useSubscriptions }
